.dnn-color-picker{
    padding: 15px;
    max-width: 400px;
    .dnn-color-sliders{
        display:flex;
        flex-direction: column;
        min-width: 200px;
        .dnn-color-s-b{
            border: 1px solid #ccc;
            padding-bottom: var(--color-box-height, 50%);
            position: relative;
            background-color: red;
            &:before{
                content: '';
                    position: absolute;
                    top:0;
                    left:0;
                    width: 100%;
                    height:100%;
                    z-index:1;
                    background: linear-gradient(to right, white, red);
                    mix-blend-mode: saturation;
            }
            &:after{
                content: '';
                position: absolute;
                top:0;
                left:0;
                width: 100%;
                height:100%;
                z-index:2;
                background: linear-gradient(to bottom, white, black);
                mix-blend-mode: luminosity;
            }
            button{
                position: absolute;
                bottom: calc(50% - 4px);
                left: calc(50% - 4px);
                width: 8px;
                height: 8px;
                z-index: 3;
                display: block;
                background: none;
                border: none;
                margin-left: -4px;
                margin-bottom: -4px;
                padding: 7px;
                background-color: #fff;
                border-radius: 50%;
                &:before{
                    content:'';
                    position: absolute;
                    top: -1px;
                    left: -1px;
                    border-radius: 50%;
                }
                &:after{
                    content:'';
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    border-radius: 50%;
                    width: 10px;
                    height: 10px;
                    border: 2px solid #ccc;
                }
            } 
        }
        .dnn-color-bar {
            display: flex;
            align-items: center;
            margin-top: 15px;
            .dnn-color-result {
                flex-direction: column;
                width: 50px;
                height: 50px;
                border-radius: 50%;
                background: red;
            }
            .dnn-color-hue{
                flex: auto;
                margin-left: 10px;
                height: 16px;
                border: 1px solid #ccc;
                position: relative;
                background: linear-gradient(
                    to right, 
                    #f00 0, 
                    #ff0 17%,
                    #0f0 33%,
                    #0ff 50%,
                    #00f 67%,
                    #f0f 84%,
                    #f00 100%
                );
                button{
                    width: 10px;
                    height: 20px;
                    position: absolute;
                    top: -2px;
                    left: calc(50% - 4px);
                    border: 0;
                    padding: 0;
                    background-color: transparent;
                    padding-left: -8px;
                    &:before{
                        content:'';
                        position: absolute;
                        top: -2px;
                        left: 0px;
                        border-radius: 3px;
                        width: 100%;
                        height: 100%;
                        border: 1px solid #ccc;
                        background-color: #fff;
                    }
                }
            }
        }
    }
    .dnn-color-fields{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        .dnn-color-mode-switch {
            display: flex;
            align-items: flex-end;
            padding: .5em;
            button {
                background-color: transparent;
                border: none;
                svg {
                    width: 3em;
                    height: 3em;
                    pointer-events: none;
                    outline: none;
                }
            }
        }
        .dnn-rgb-color-fields {
            display: flex;
            justify-content: space-evenly;
            .dnn-rgb-color-field {
                display: flex;
                flex-direction: column;
                flex: auto;
                text-align: center;
                padding: .5em;
                label {
                    padding-bottom: .25em;
                }
                input{
                    border-radius: var(--dnn-button-radius, 3px);
                    border: 1px solid #ccc;
                    padding: 0.5em;
                    padding-left: 1.3em;
                    text-align: center;
                    &.red{
                        border-color: red;
                    }
                    &.green{
                        border-color: green;                
                    }
                    &.blue{
                        border-color: blue;
                    }            
                }
            }
        }
        .dnn-hsl-color-fields {
            display: flex;
            justify-content: space-evenly;
            .dnn-hsl-color-field {
                display: flex;
                flex-direction: column;
                flex: auto;
                text-align: center;
                padding: .5em;
                label {
                    padding-bottom: .25em;
                }
                input{
                    border-radius: var(--dnn-button-radius, 3px);
                    border: 1px solid #ccc;
                    padding: 0.5em;
                    padding-left: 1.3em;
                    text-align: center;
                }
            }
        }
        .dnn-hex-color-fields {
            display: flex;
            justify-content: space-evenly;
            .dnn-hex-color-field {
                display: flex;
                flex-direction: column;
                flex: auto;
                text-align: center;
                padding: .5em;
                label {
                    padding-bottom: .25em;
                }
                .hex-input{
                    position: relative;
                    border-radius: var(--dnn-button-radius, 3px);
                    border: 1px solid #ccc;
                    padding: 0.323em;
                    text-align: center;
                    input{
                        border:0;
                        padding:0;
                        margin:0;
                        width:100%;
                        height:100%;
                        text-align:center;
                    }
                    button{
                        position: absolute;
                        height: 100%;
                        top: 0;
                        right: 1em;
                        background-color: transparent;
                        border:0;
                        padding:0;
                        margin:0;
                        svg{
                            min-width: 1em;
                        }
                    }
                }
            }
        }
    }
} 